import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
  {
    path: '/cn/download',
    name: 'MiYouZh',
    component: () => import('../views/download/cn/index.vue'),
  },
  {
    path: '/en/download',
    name: 'MiYouEn',
    component: () => import('../views/download/en/index.vue'),
  },
]

const router = new VueRouter({
  routes,
  mode: 'hash',
})

export default router
